export default __webpack_public_path__ + "static/media/image-2.b25d3820.jpg";